<script>
import _chunk from 'lodash/chunk'
import Layout from '@layouts/main'

import { setComputed } from '@state/helpers'
import formatDate, { dateDiffInMinutes, formatLunar } from '@utils/format-date'

import ViewNull from './components/ViewNull'
import ViewTickets from './components/ViewTickets'

export default {
  page() {
    return {
      title: this.order.merchant.name,
    }
  },
  components: { Layout, ViewNull, ViewTickets },
  filters: {
    formatDate,
    formatLunar,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isModalImageActive: false,
      modalImageImage: '',
      windowLocation: window.location
    }
  },
  computed: {
    ...setComputed,
    orderTimeInterval() {
      const dateDiff = dateDiffInMinutes(
        this.order.startDate,
        this.order.endDate
      );

      if (dateDiff > 60 * 24 * 30) {
        return this.$tc(
          'global.ABOUT_TIME_MOUTH',
          dateDiff / (60 * 24 * 30),
          {
            minute: Math.floor(dateDiff / (60 * 24 * 30)),
          } /* (預計{minute}個月) */
        )
      } else if (dateDiff > 60 * 24) {
        return this.$tc(
          'global.ABOUT_TIME_DAY',
          dateDiff / (60 * 24),
          { minute: Math.floor(dateDiff / (60 * 24)) } /* (預計{minute}天) */
        )
      } else if (dateDiff > 60) {
        return this.$tc(
          'global.ABOUT_TIME_HOUR',
          dateDiff / 60,
          { minute: Math.floor(dateDiff / 60) } /* (預計{minute}小時) */
        )
      } else {
        return this.$tc(
          'global.ABOUT_TIME_MINUTE',
          dateDiff,
          { minute: Math.floor(dateDiff) } /* (預計{minute}分鐘) */
        )
      }
    },
    orderProductType() {
      return this.order.productType || 'activity'
    },
    isNullOrder() {
      return (
        typeof this.order === 'object' && Object.keys(this.order).length === 0
      )
    },
  },
  methods: {
    openModalImage(isUse, image) {
      if (!isUse) {
        this.isModalImageActive = true;
        this.modalImageImage = image
      }
    },
    chunkTicketCodes(codeArray, size) {
      return _chunk(codeArray, size)
    },
    handleToOrder() {
      this.$router.push({
        name: 'order-detail',
        params: {
          merchantAlias: this.order.merchant.alias,
          orderKey: this.order.id,
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    handleToMemberOrder() {
      this.$router.push({
        name: 'member-order-item',
        params: {
          merchantAlias: this.order.merchant.alias,
          orderKey: this.order.id,
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    handleToProduct() {
      this.$router.push({
        name: 'booking-product',
        params: {
          merchantAlias: this.order.merchant.alias,
          productType: this.order.productType,
          productId: this.order.productAlias,
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    handleToBookingHome() {
      this.$router.push({
        name: 'home',
        params: { merchantAlias: this.order.merchant.alias },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    handleContact() {
      const vnodes = []

      if (this.order.merchant.email) {
        vnodes.push(
          <a href={`mailto:${this.order.merchant.email}`}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="envelope"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
            >
              <path
                fill="currentColor"
                d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
              ></path>
            </svg>
            {this.order.merchant.email}
          </a>
        )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
          <a href={`tel:${this.order.merchant.phoneNumber}`}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="mobile-android-alt"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
            >
              <path
                fill="currentColor"
                d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
              ></path>
            </svg>
            {this.order.merchant.phoneNumber}
          </a>
        )
      }
      const createElement = this.$createElement
      const messageElement = createElement('p', null, vnodes)

      this.$alert(
        messageElement,
        this.$t(
          'global.CONTACT_PREFIX',
          { name: this.order.merchant.name } /* 聯繫{name} */
        ),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t(
            'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
          ),
          confirmButtonClass: 'button is-primary is-rounded',
        }
      )
    },
    takeLast(text, num = 5) {
      return text.substring(text.length - num, text.length)
    },
    formatText(type, data = {}) {
      switch (type) {
        case 'male':
          return '男';
        case 'female':
          return '女';
        case 'unit':
          const unitMap = {
            light: '盞',
            treasury: '份',
            puja: '人',
            pudu: '份',
            worshipset: '盞',
          };

          return `共${data.qty * data.size}${unitMap[this.orderProductType]}`;
        case 'light':
        case 'worshipset':
          return formatLunar(this.order.startDate);
        case 'treasury':
        case 'pudu':
          return formatDate(new Date(`${this.order.startDate}`), 'dateSlash');
        case 'puja':
          const inventoryTitle = ` ${this.order.inventoryTitle}` || '';

          return `${formatDate(this.order.startDate, 'dateTime')}${inventoryTitle}`;
        default:
          return ''
      }
    },
  },
}
</script>

<template>
  <Layout>
    <ViewTickets
      v-if="!isNullOrder"
      :order="order"
      :tickets="tickets"
    />
    <ViewNull
      v-else
    />
  </Layout>
</template>

<style lang="scss" module>
.ticketHeader {
  &__title {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 1.5rem;
    font-weight: normal;
    .ticketSubtext {
      font-weight: 400 !important;
      line-height: 21px;
      color: #575c5c;
      text-align: justify;
      letter-spacing: 0.8px;

    }
    .orderUnittext {
      margin-top: 1rem;
      font-size: 14px;
      line-height: 18px;
      color: #852426;
      letter-spacing: 0.89px;
    }
  }
  &__name {
    @extend %typography-medium;

    font-size: 22px;
    font-weight: $heading-font-weight;
    line-height: 30px;
    letter-spacing: 1.1px;

  }
  &__icon {
    padding: 0 2rem;

    @include mobile {
      padding: 0 1.5rem;
    }
    &:hover {
      color: $color-primary;
    }
    .icon {
      margin-left: 1rem;
    }
    .toggleText {
      display: inline-block;
      width: 35px;
    }
  }
}
.qrcodeGroup {
  padding: 1.5rem 0;
  &:not(:last-child) {
    border-bottom: 1px dashed $color-border-base;
  }
  &__header {
    margin-bottom: 1.5rem;
    color: $grey;
  }
  &__item {
    display: flex;
    flex-wrap: wrap;
    .qrcodeItem {
      flex: 0 0 50%;
      flex-wrap: wrap;
      margin-bottom: 2rem;
      text-align: center;
      .qrcodeImg {
        position: relative;
        width: 220px;
        max-width: 35vw;
        margin: 0 auto 0.5rem;
        img:not(.isUseQrcode) {
          &:hover {
            cursor: pointer;
            box-shadow: 0 0 25px 0 rgba(178, 180, 181, 0.35);
            transition: box-shadow 0.3s;
          }
        }
      }
      .isUseQrcode {
        opacity: 0.65;
      }
      .iconCheck {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 70px;
        margin-top: -35px;
        margin-left: -35px;
        font-size: 45px;
        color: #ccff8f;
        background: #4caf4f;
        border-radius: 100%;
      }
    }
    .singleQrcode {
      flex: 0 0 100%;
    }
  }
}
.buttonPrimary {
  width: 100%;
}

.orderTable {
  margin-top: 35px;
  margin-bottom: 70px;
  border-bottom: 1px solid #d0d0d0;
  table {
    border-collapse: collapse !important;
    thead {
      tr {
        background-color: #f0e4d6;
        th {
          padding-top: 18px;
          padding-bottom: 18px;
          padding-left: 1.5rem;
          font-size: 15px;
          font-weight: 400 !important;
          line-height: 21px;
          color: #100101;
          letter-spacing: 1.03px;
          border: 1px solid #f0e4d6;
        }
      }
    }
    tbody {
      tr {
        td {
          font-size: 15px;
          font-weight: 400 !important;
          line-height: 25px;
          color: #100101;
          letter-spacing: 1.03px;
        }
      }
    }

    .tableColumn {
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 1.5rem;
      border: 1px solid #d0d0d0;

      @include mobile {
        padding-left: 13px;
        text-align: left !important;
      }
      span {
        @include mobile {
          display: block !important;
          width: 10rem !important;
        }
      }
      img:hover {
        cursor: pointer;
        opacity: 0.75;
      }
    }
  }
}

.orderDescription {
  font-size: 19px;
  font-weight: 500;
  line-height: 26px;
  color: #4a4a4a;
  letter-spacing: 0.5px;
}
</style>
